//AvatarSettings.tsx — the avatar mirror's gear panel: Start, the one Decart setting, camera, carousel

import { useEffect } from 'react'
import type { VideoPreference } from '../config/videoPreference'
import type { CharacterOverride } from '../tryon/characterOverride'
import { CameraSection } from '../ui/CameraSection'
import { Row, Section } from '../ui/panel'
import { PowerToggle } from '../ui/PowerToggle'

interface Props {
	settings: CharacterOverride
	preference: VideoPreference
	session: {
		live: boolean
		busy: boolean
		canStart: boolean
		onToggle: () => void
	}
	onSettings: (patch: Partial<CharacterOverride>) => void
	onPreference: (patch: Partial<VideoPreference>) => void
	onClose: () => void
}

export function AvatarSettings({ settings, preference, session, onSettings, onPreference, onClose }: Props) {
	useEffect(() => {
		const onKey = (event: KeyboardEvent) => {
			if (event.key === 'Escape') onClose()
		}
		window.addEventListener('keydown', onKey)
		return () => window.removeEventListener('keydown', onKey)
	}, [onClose])

	return (
		<div className="catcher" onPointerDown={onClose} role="presentation">
			<div
				className="popover"
				role="dialog"
				aria-label="Settings"
				onPointerDown={(event) => event.stopPropagation()}
			>
				<div className="popover-action">
					<PowerToggle
						wide
						subject="avatar"
						live={session.live}
						busy={session.busy}
						disabled={!session.canStart}
						onToggle={session.onToggle}
					/>
				</div>

				<Section title="Lucy">
					<Row
						label="Enhance prompt"
						hint="On: Decart rewrites the prompt to fit the video and image (its guide says keep it on). Off: Lucy reads the admin prompt word for word."
					>
						<input
							type="checkbox"
							checked={settings.enhance}
							onChange={(event) => onSettings({ enhance: event.target.checked })}
						/>
					</Row>
				</Section>

				<CameraSection preference={preference} onChange={onPreference} />

				<Section title="Display">
					<Row label="Show characters" hint="The carousel at the bottom. Off for a clean full-screen mirror.">
						<input
							type="checkbox"
							checked={preference.showDock}
							onChange={(event) => onPreference({ showDock: event.target.checked })}
						/>
					</Row>
				</Section>
			</div>
		</div>
	)
}
